import { RegisterOptions, UseFormReturn } from "react-hook-form";

import { getValueByString } from "../Utils";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useGlobalData } from "../../GlobalDataProvider";
import { IdText } from "../../../types/ModuleDatas";

interface IProps {
  label: string;
  fieldName: string;
  formHook: UseFormReturn;
  options?: RegisterOptions;
  defaultValue?: any;
  children?: React.ReactNode;
  items: string[] | IdText[] | number[];
  isDisabled?: boolean;
  showWhenIsDisabled?: boolean;
  className?: string;
  tooltipId?: string;
  tooltipClass?: string;
}

const SelectEditor = ({ label, fieldName, formHook, options, defaultValue, children, items, isDisabled, className, tooltipId, tooltipClass, showWhenIsDisabled }: IProps) => {
  const { register, formState } = formHook;
  const globalData = useGlobalData();
  const errors = formState.errors;
  const isInValid: any = getValueByString(errors, fieldName);

  const sItems = items as string[];
  const oItems = items as IdText[];
  let itemType = "s";
  if (items.length) {
    const firstItem = items[0] as any;
    if (firstItem.id !== undefined && firstItem.text !== undefined) itemType = "o";
  }

  const renderTooltip = (props: any) => {
    if (isInValid)
      return (
        <Tooltip {...props} className="validationErrorTooltip">
          <span>{isInValid.message}</span>
        </Tooltip>
      );
    if (tooltipId && globalData.data?.Tooltip.mapTooltip[tooltipId])
      return (
        <Tooltip {...props} className={"defaultTooltip " + (tooltipClass ?? "")}>
          <span style={{ whiteSpace: "pre-line", display: "inline-block" }} dangerouslySetInnerHTML={{ __html: globalData.data?.Tooltip.mapTooltip[tooltipId] }}></span>
        </Tooltip>
      );
    else return <></>;
  };

  const getSelectEditor = () => {
    var htmlPart;

    //Input group base
    htmlPart = (
      <div className={children ? "input-group w-100" + (className ? " " + className : "") : "w-100 "}>
        {isDisabled ? (
          <OverlayTrigger placement="top" overlay={renderTooltip}>
            {showWhenIsDisabled ? (
              <input id={label} type="text" {...register(fieldName)} disabled={isDisabled} className={"form-control"} />
            ) : (
              <input value={""} type="text" disabled={isDisabled} className={"form-control"} />
            )}
          </OverlayTrigger>
        ) : (
          <OverlayTrigger placement="top" overlay={renderTooltip}>
            <select
              defaultValue={defaultValue}
              disabled={isDisabled}
              className={"form-select " + (isInValid ? "is-invalid" : "")}
              aria-label="Default select example"
              {...register(fieldName, options)}
            >
              {itemType === "s"
                ? sItems.map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))
                : oItems.map((o) => (
                    <option key={o.id} value={o.id}>
                      {o.text}
                    </option>
                  ))}
            </select>
          </OverlayTrigger>
        )}
        {children}
        {/* {errors[fieldName]?.message && <div className="invalid-feedback">{errors[fieldName]?.message?.toString()}</div>} */}
      </div>
    );

    //Label if exists
    if (label) {
      htmlPart = (
        <label className="form-label w-100">
          {label}
          {htmlPart}
        </label>
      );
    }

    htmlPart = <div className={"input-group has-validation" + (className ? " " + className : "")}>{htmlPart}</div>;

    return htmlPart;
  };

  return <>{getSelectEditor()}</>;
};

export default SelectEditor;
